import { render } from "./ProofPrinter.vue?vue&type=template&id=865e4a38&scoped=true"
import script from "./ProofPrinter.vue?vue&type=script&lang=js"
export * from "./ProofPrinter.vue?vue&type=script&lang=js"

import "./ProofPrinter.vue?vue&type=style&index=0&id=865e4a38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865e4a38"]])

export default __exports__